/**
 * 自定义公式编辑器风格
 */
import CodeMirror from 'codemirror'
import { util } from './formulaUtil'

const hotFormulas = require('hot-formula-parser').SUPPORTED_FORMULAS

let aCondition = util._aLogicFn;
let _functionList, aFunction, _memberList, aMember
_functionList = aFunction = util._aFunction;
_memberList = aMember = util._aMembers.map(item => item.name);

let conditionsRegex = new RegExp("\\b((" + aCondition.join(")|(") + "))", 'i');
let functionsRegex = new RegExp("\\b((" + aFunction.join(")|(") + "))(?=\\s*\\()", 'i');
let memberRegex = new RegExp("\\b((" + aMember.join(")|(") + "))(?!\\s*\\()", 'i');

//公式语法高亮解析
let formulaToken = (stream, state) => {
    if (stream.eatSpace()) {
        return null;
    }
    if (stream.match(memberRegex)) {
        return "member";
    } else if (stream.match(conditionsRegex)) {
        return "condition";
    } else if (stream.match(functionsRegex)) {
        return "function";
    } else if (stream.match(/[true|false|null]/i)) {
        return "boolean";
    } else if (stream.match(/^[0-9.]+/)) {
        return "number";
    } else if (stream.match(/^[\+|\-|\*|\/]/g)) {
        return "arithmetic";
    } else if (stream.match(/^=\s*=/)) {
        return "error";
    } else if (stream.match(/^[<\s*=|>\s*=|=|!\s*=|<|>]/g)) {
        return "bool";
    } else if (stream.match(/^[,|;]/)) {
        return "comma";
    } else if (stream.match(/^[(|\[|)|\]]/)) {
        return "bracket";
    } else if (stream.match(/"(?:[^"\\]|\\.)*"/)) {
        return "string";
    } else {
        stream.next();
        return "error";
    }
}

//自动联想索引提示
let hint = (editor, options) => {
    options.completeSingle = false;
    let cur = editor.getCursor(), curLine = editor.getLine(cur.line);
    let inputChart = curLine.charAt(cur.ch - 1)
    let word = '', regex = /[a-zA-Z]+/gi, res

    if (!/[a-zA-Z]+/.test(inputChart)) {
        return
    }

    curLine = curLine.substr(0, cur.ch)
    while ((res = regex.exec(curLine)) != null) {
        word = res[0];
    }

    let hint = [];
    let reg = new RegExp(`^${word}`,"i");
    hint = _functionList.filter(item => reg.test(item))
                .concat(_memberList.filter(item => reg.test(item))).sort()
    hint = hint.reduce((prev, cur) => prev.includes(cur) ? prev : [...prev, cur], [])
    if (hint.length > 0) {
        return {
            list: hint,
            from: CodeMirror.Pos(cur.line, cur.ch - word.length),
            to: CodeMirror.Pos(cur.line, cur.ch)
        };
    }
}

//获取所有明细节点
let getTreeDetailNodes = (tree, arr) => {
    if (!arr) arr = []
    tree.forEach((currentValue) => {
        if (!currentValue.children) {
            arr.push(currentValue)
        } else {
            arr.join(getTreeDetailNodes(currentValue.children, arr))
        }
    })
    return arr
}

//自定义语法构造器
export let builder = {
    init: (functions, constants) => {
        conditionsRegex = new RegExp("\\b((" + aCondition.join(")|(") + "))", 'i');
        aFunction = hotFormulas
        if (functions) {
            let retArr = getTreeDetailNodes(functions)
            aFunction = aFunction.concat(retArr.map(item => !item.children && item.name))
        }
        _functionList = aFunction.sort()
        functionsRegex = new RegExp("\\b((" + aFunction.join(")|(") + "))(?=\\s*\\()", 'i');
        builder.functionsRegex = functionsRegex
        builder.functionList = _functionList
        if (constants) {
            _memberList = constants.map(item => item.name).sort()
            memberRegex = new RegExp("\\b((" + _memberList.join(")|(") + "))(?!\\s*\\()", 'i');
            builder.memberRegex = memberRegex
            builder.memberList = _memberList
        }
    },
    doRegister: () => {
        CodeMirror.defineMode('webFormula', function (conf, parserConf, functionsRegex) {
            return {
                startState: () => { return { context: 0, sTemp: "" } },
                token: formulaToken
            };
        });
        CodeMirror.defineMIME("text/x-webFormula", "webFormula");
        CodeMirror.registerHelper("hint", "webFormula", hint);
    },
}
